var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhoServe2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 132,
    viewBox: "0 0 295 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.591 114.485L295 131.788C293.773 98.3642 294.542 29.7764 294.08 21.3117C293.619 12.8817 284.415 0.963577 273.37 0.902374C193.292 0.458694 30.4503 -0.885651 20.2496 0.902374C10.1248 2.67709 1.84088 14.2128 0 19.9806V131L18.5 115C18.6534 85.5692 18.381 30.7896 18.869 27.9669C19.3292 25.3048 23.3177 21.4596 25.7722 19.9806C103.703 19.9806 261.142 19.5792 267.387 19.9806C274.29 20.4243 276.131 26.4879 276.591 29.7416V114.485Z",
    fill: "#ED2025"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoServe2);
export default __webpack_public_path__ + "static/media/who_serve_2.ac02d4762c123c7c66cc9f51406ae7bb.svg";
export { ForwardRef as ReactComponent };